<template>
  <el-dialog :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" top="10vh" class="create-project-dialog" width="630px">
    <div slot="title" class="dialog-title">相似项目<span class="field-alert ft14">（同职能模块项目）</span></div>
    <div>
      <div v-loading="loading" class="project-box mb10">
        <div v-for="(item, index) in projects" :key="`project${index}`" class="project-item" @click="openProject(item)">
          <p>{{item.客户公司}}--{{item.项目名称}}（{{item.编号}}）</p>
        </div>
      </div>
      <el-pagination
        background
        :current-page="page"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    hasQuestiones: { type: Array, default: () => [] },
  },
  data() {
    return {
      dialogVisible: false,
      projects: [],
      page: 1,
      total: 0,
      pageSize: 10,
      loading: false,
    }
  },
  methods: {
    open(category) {
      if(!category) return this.$message.error('该项目没有填写职能模块')
      this.category = category
      this.dialogVisible = true
      this.loadData()
    },
    openProject(project) {
      window.open(`${window.origin}/#/project20/${project._id}`)
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    async loadData() {
      this.loading = true
      const param = Object.assign(
        { query: { 职能模块:this.category } },
        { page: this.page, limit: this.pageSize },
        { sort: this.sort },
      )
      const res = await app.service('project').list(param)
      const { status, msg, data, total } = res
      if (status === 'success') {
        this.projects = data
        this.total !== total && (this.total = total)
      } else {
        this.projects = []
        this.$message.error(msg)
      }
      this.loading = false
    },
  },
}
</script>
<style>
.create-project-dialog .el-dialog__body {
  padding-top: 0px;
}
</style>
<style scoped src="../../css/newCreateProject.css"></style>
<style scoped>
.hasset-field-box {
  display: flex;
  flex-wrap: wrap;
}
.hasset-field {
  flex: none;
  min-width: 100px;
  margin: 10px;
}
.footer-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.dialog-title {
  font-size: 16px;
  text-align: left;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 8px;
}
.ft14{
  font-size: 14px;
}
.create-project-alert-box {
  border: 1px solid #d4d4d4;
  padding: 10px;
  border-radius: 4px;
}
.project-box{
  min-height: 300px;
}
.project-item {
  padding-top: 5px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  cursor: pointer;
}
.text-btn {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
  margin-right: 20px;
  flex: none;
  word-break: keep-all;
}

.warning-text {
  color: #f56c6c;
}
.mt10 {
  margin-top: 10px;
}
</style>
